import React from 'react'
import CertificadoDigitalListPageContainer from './CertificadoDigitalListPageContainer'

export class CertificadoDigitalListPage extends React.Component {
  render() {
    return <CertificadoDigitalListPageContainer {...this.props} />
  }
}
